import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { calGuard } from '@cvx/cal-angular';
import { Landing } from './pages/landing/landing';
import { APP_ROUTES } from './core/constants/app-navigation.constants';

export const routes: Routes = [
  {
    path: '',
    component: Landing,
    canActivate: [calGuard],
    children: [
      /** HOME TAB */
      {
        path: '',
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
      },
      {
        path: APP_ROUTES.HOME,
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
      },

      /** ISSUES TAB */
      {
        path: APP_ROUTES.ISSUES,
        loadComponent: () =>
          import('./components/Issues-Tab/issues-page/issues-page').then((m) => m.IssuesPage),
      },

      /** MAINTENANCE TAB  */
      {
        path: APP_ROUTES.MAINTENANCE,
        loadComponent: () =>
          import('./components/Maintenance-Tab/maintenance-page/maintenance-page').then(
            (m) => m.MaintenancePage,
          ),
      },

      /** AMENDED RETURN */
      {
        path: APP_ROUTES.AMENDED_RETURN,
        loadComponent: () =>
          import('./components/amended-return/amended-return').then((m) => m.AmendedReturn),
      },

      /** TAX-ACCOUNTING TAB */
      {
        path: APP_ROUTES.TAX_ACCOUNTING,
        loadComponent: () =>
          import('./components/tax-accounting-page/tax-accounting-page').then(
            (m) => m.TaxAccountingPage,
          ),
      },

      /** USERS TAB */
      {
        path: APP_ROUTES.USER,
        loadComponent: () => import('./components/users/users').then((m) => m.Users),
      },

      /** ERROR Page */
      {
        path: APP_ROUTES.ERROR,
        loadComponent: () => import('./pages/error/error').then((c) => c.Error),
      },

      /** Unauthorized Page */
      {
        path: APP_ROUTES.UNAUTHORIZED,
        loadComponent: () => import('./pages/unauthorized/unauthorized').then((c) => c.Unauthorized),
      },

      /** DEFAULT */
      {
        path: '**',
        redirectTo: `${APP_ROUTES.HOME}`,
      },
      {
        path: '*',
        redirectTo: `${APP_ROUTES.HOME}`,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
